<!--<mat-form-field>-->
<!--<mat-placeholder>-->
<!--{{label}}-->
<!--</mat-placeholder>-->
<!--<input #inputElement-->
<!--matInput-->
<!--autocomplete="off"-->
<!--[(ngModel)]="addressValue"-->
<!--[disabled]="disabled || !!value"-->
<!--[required]="isRequired">-->
<!--<mat-icon class="clear-icon" *ngIf="!!value" (click)="clear()">clear</mat-icon>-->
<!--</mat-form-field>-->

<ig-field #inputElement [label]="label" [label2]="label2" [isRequired]="isRequired" [disabled]="disabled" icon="room"
    [icon]="!!value?'clear':'room'" (onIconClick)="clear()" [formControl]="locationFormGroup.get('address')"
    [(ngModel)]="addressValue">
</ig-field>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/address.input/address.input.component.html